import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { ERRORS, messages } from 'app/config/constants';
import { queryClient } from 'app/app';
import { toast } from 'react-toastify';
import { fetchCaseRequestInfo, saveCaseRequestInfo } from './case-request-info-form.service';
import { CaseRequestInfoModel } from '../model/case-request-info-form.model';

export const fetchCaseRequestInfoQuery = (caseUuid: string) => {
  return useQuery({
    queryKey: ['case-request-info', { caseUuid: caseUuid }],
    queryFn: () => fetchCaseRequestInfo(caseUuid),
    enabled: !!caseUuid,
  });
};

export const saveCaseRequestInfoMutation = (caseUuid: string) => {
  return useMutation({
    mutationFn: (caseRequestInfo: CaseRequestInfoModel) => {
      return saveCaseRequestInfo(caseUuid, caseRequestInfo);
    },
    onSuccess: (data, variables) => {
      showToast(toast.success, messages.DATA_SAVED);
      queryClient.invalidateQueries({queryKey: ['case-request-info']})
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
};

